import Header from "components/Headers/Header";
import React, { useEffect, useRef, useState } from "react";
import {
    Button,
    Card,
    CardBody,
    CardHeader,
    Col,
    Container,
    Form,
    FormGroup,
    Input,
    Label,
    Row,
    Table,
} from "reactstrap";
import { toast } from "react-toastify";
import Unauthorized from "views/Pages/Unauthorized";
import Moment from "react-moment";
import moment from "moment";
import { GetApiActionWithAuthorization, PostApiWithAuthorizationAction } from "../../constantFunctions/apiActions";
import { monthOptions, dayOptions, paidOptions } from "../../constants/ticketConstants";
import { resetState } from "../../redux/common/commonAction";
import { connect } from "react-redux";
import DatePicker from 'react-datepicker';

import isSameISOWeek from 'date-fns/isSameISOWeek';
import format from "date-fns/format";
import startOfISOWeek from 'date-fns/startOfISOWeek';
import endOfISOWeek from 'date-fns/endOfISOWeek';

function CoinReceipt(props) {
    const [unauthorized, setUnauthorized] = useState(false);
    const [data, setData] = useState([]);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [filter, setFilter] = useState({
        page: 0,
        startDay: moment().subtract(7, 'days').unix(),
        endDay: moment().unix()
    });

    useEffect(() => {
        load();
    }, []);

    if (data.error && !unauthorized) {
        if (data.error.status === 403) {
          setUnauthorized(true);
        } else if (data.error.status === 440) {
          toast.error(data.error.message, {
            position: toast.POSITION.TOP_CENTER,
          });
          props.history.push("/auth/login");
        }
    }

  const load = (params) => {
    Object.assign(filter, params);
    GetApiActionWithAuthorization("high-value-ticket/get-receipt-data/", filter)
    .then((res) => {
        setData(res.data)
    })
    .catch((err) => {
      if (err.status === 403) {
        setUnauthorized(true);
      } else if (err.status === 440) {
        props.resetState();
        toast.error(err.message, { position: toast.POSITION.TOP_CENTER });
        props.history.push("/auth/login");
      }
    });
  };

    const renderReferHeadTableData = () => {
        return (
            <thead className="thead-light">
                <tr>
                    <th scope="col">Name</th>
                    <th scope="col">Date</th>
                    <th scope="col">Amount</th>
                </tr>
            </thead>
        );
    };

    const renderReferBodyTableData = () => {
        return data.map((_data, i) => {
            return (
                <>
                    <tr>
                        <td scope="col" style={{textTransform: 'uppercase'}}>{_data.fullName}</td>
                        <td scope="col">{_data.dates.split(',').join('\n')}</td>
                        <td scope="col">${parseInt(_data.totalAmount)}</td>
                    </tr>
                </>
            )
        });
    };
    const displayRange = () => {
        const startDate = moment().subtract(7, 'days').format('MMM DD, YYYY');
        const endDate = moment().format('MMM DD, YYYY');
        return `${startDate} – ${endDate}`;
    }
    //
    return unauthorized ? (
        <Unauthorized />
      ) : (
        <>
          <Header />
          {/* Page content */}
          <Container className="mt--9 main-content" fluid>
            <Card className="card-height shadow">
              <CardHeader>
                <div className="text-center">
                    <h1>CR Cash Report</h1>
                </div>
              </CardHeader>
              <CardBody className="checks-main-content page-main-content">
                {/*<div className="mb-2 date-picker-week-range">
                    <span class="mx-1" style={{fontSize: "16px"}}>Select Week Range: </span>
                    <DatePicker
                        selected={selectedDate}
                        onChange={(date) => {
                            setSelectedDate(date);
                            const startDate = startOfISOWeek(date);
                            const endDate = endOfISOWeek(date);
                            load({
                                startDay: moment(format(startDate, 'yyyy-MM-dd')).unix(),
                                endDay: moment(format(endDate, 'yyyy-MM-dd')).unix()
                            });
                        }}
                        showWeekNumbers
                        dayClassName={(date) =>
                            isSameISOWeek(date, selectedDate)
                            ? 'react-datepicker__day--selected'
                            : undefined
                        }
                        calendarStartDay={1}
                    />
                </div>*/}
                <div className="mb-2">
                    <span class="mx-1" style={{fontSize: "18px"}}>
                        Date Range: <span class="">{displayRange()}</span>
                    </span>
                </div>
                <Row>
                    <Col md="6">
                        <Table
                            className="table-listing items-list-table high-value-ticket-table"
                            responsive
                            bordered
                            style={{fontSize: '16px'}}>
                            {renderReferHeadTableData()}
                            <tbody>{renderReferBodyTableData()}</tbody>
                        </Table>
                    </Col>
                </Row>
              </CardBody>
            </Card>
          </Container>
        </>
    );
}

const mapStateToProps = (state) => {
    return {
        userType: state.loginUserReducer.userType
    };
  };
  
const mapDispatchToProps = (dispatch) => {
    return {
        resetState: () => dispatch(resetState())
    };
};
  
export default connect(mapStateToProps, mapDispatchToProps)(CoinReceipt);